import React, { useEffect, useMemo, useState } from "react";
import { CustomerViewDetailsViewViewOpenActivitiesInfoProps } from "./customer-view-details-view-open-activities-info.props";
import "./customer-view-details-view-open-activities-info.scss";
import { Tab, Tabs, IconButton, Tooltip } from "@mui/material";
import {
  TAB_OPTIONS,
  taskColumns,
  completedTaskColumns,
} from "./customer-view-details-view-open-activities-info.constants";
import DataTable from "../../../../../campaign/campiagn-view/campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/task-table/task-table";
import { useSetLoading } from "../../../../../../common/hooks/appearance";
import {
  getMeetingColumns,
  getCallColumns,
} from "./common-dialog-task/common-dialog-helper";
import CommonTaskDialog from "./common-dialog-task/common-dialog-task";
import CommonMeetingDialog from "./common-dialog-task/common-meeting-dialog";
import {
  AlertComponent,
  ConfirmationPopup,
} from "../../../../../../common/components";
import { getFullName } from "./common-dialog-task/common-dialog-helper";
import { getCustomerDetails } from "../../../../../../api/customer";
import { useLogin } from "../../../../../../common/hooks/useUser";
import EmailSetUpBanner from "../../../../../../common/components/email-setup-required-banner/email-setup-banner";
import AddNewCallDropdown from "./add-call-dropdown";
import CommonCallDialog from "./common-dialog-task/common-dialog-call";
import CommonCallCancelDialog from "./common-dialog-task/cancel-call";
import CommonCallLogDialog from "./common-dialog-task/common-dailouge-call-log";
import CommonRescheduleCallDialog from "./common-dialog-task/reschedule-call";
import ConfirmInfo from "../../../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";
import EditIcon from "../../../../../../assets/icons/edit.svg";
import DoneIcon from "../../../../../../assets/icons/green-tick.svg";
import archiveIcon from "../../../../../../assets/icons/archive-icon.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  deleteCall,
  deleteMeeting,
  deleteTask,
  editTask,
  getCalls,
  getMeetings,
} from "../../../../../../api/campaign";
import ActionsMenu from "../../../../../../common/components/mui-table/actions-menu";

const CustomerViewDetailsViewOpenActivitiesInfo: React.FC<
  CustomerViewDetailsViewViewOpenActivitiesInfoProps
> = (props: any) => {
  const {
    allLeadData,
    disableEdit,
    setViewTaskvalue,
    setCrumbMappingOption,
    permissions,
    setViewMeetingvalue,
    setViewCallValue,
  } = props;
  const [indexValue, setIndexValue] = React.useState(0);
  const [customerViewDetails, setCustomerViewDetails] = useState<any>(null);
  const [activeTab, setActiveTab] = useState("Tasks");
  const [closedActiveTab, setClosedActiveTab] = useState("Tasks");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [tasksCount, setTasksCount] = useState(0);
  const [meetingsCount, setMeetingsCount] = useState(0);
  const [callsCount, setCallsCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [editDataTask, setEditDataTask] = useState<any>(null);
  const [openTaskDialog, setOpenTaskDialog] = useState(false);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [openMeetingDialog, setOpenMeetingDialog] = useState(false);
  const [editDataMeeting, setEditDataMeeting] = useState<any>(null);
  const [completedMeetings, setCompletedMeetings] = useState([]);
  const fullName = getFullName(
    customerViewDetails?.first_name,
    customerViewDetails?.middle_name,
    customerViewDetails?.last_name,
  );
  const meetingColumns = getMeetingColumns(fullName);
  const [calls, setCalls] = useState([]);
  const [completedCalls, setCompletedCalls] = useState([]);
  const callColumns = getCallColumns();
  const [closedCallsCount, setClosedCallsCount] = useState(0);
  const [closedTasksCount, setClosedTasksCount] = useState(0);
  const [closedMeetingsCount, setClosedMeetingsCount] = useState(0);
  const [openCallsCount, setOpenCallsCount] = useState(0);
  const [isArchivePopupOpenForMeeting, setIsArchivePopupOpenForMeeting] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isMarkPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [selectedArchiveTask, setSelectedArchiveTask] = useState<any>(null);
  const [rescheduleCallOpen, setRescheduleCallOpen] = useState(false);
  const [markCallAsCompletedOpen, setMarkCallAsCompletedOpen] = useState(false);
  const [cancelCallOpen, setCancelCallOpen] = useState(false);
  const [meetingToDelete, setMeetingToDelete] = useState<any>(null);
  const [openCallsDialog, setOpenCallsDialog] = useState(false);
  const [openLogCallDialog, setOpenLogCallDialog] = useState(false);
  const [editDataCall, setEditDataCall] = useState<any>(null);
  const [customerOptions, setCustomerOptions] = useState<any[]>([]);
  const [isArchiveForCallPopupOpen, setIsArchiveForCallPopupOpen] =
    useState(false);
  const [callToDelete, setCallToDelete] = useState<any>(null);
  const [taskToDelete, setTaskToDelete] = useState<any>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = useState<any>(null);

  const loginDetails = useLogin();
  const isEmailConfigured = loginDetails?.isEmailConfigured;

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleAddNewClick = () => {
    if (activeTab === "Tasks") {
      setOpenTaskDialog(true);
      setEditDataTask(null);
    }
    if (activeTab === "Meetings") {
      setOpenMeetingDialog(true);
      setEditDataMeeting(null);
    }
  };
  const fetchTasks = async () => {
    setLoading(true);
    try {
      const response = await getCustomerDetails(allLeadData);
      setCustomerViewDetails(response?.data?.data);
      const allTasks = response?.data?.data?.tasks || [];
      const allMeetings = response?.data?.data?.meetings || [];
      const allCalls = response?.data?.data?.calls || [];
      const openMeetingsList = allMeetings.filter(
        (task: any) => task.status !== "closed",
      );
      const closedMeetingsList = allMeetings.filter(
        (task: any) => task.status === "closed",
      );
      const openCallsList = allCalls.filter(
        (call: any) =>
          call.outgoing_call_status !== "Completed" &&
          call?.outgoing_call_status !== "Cancelled",
      );
      const closedCallsList = allCalls.filter(
        (call: any) =>
          call?.outgoing_call_status === "Completed" ||
          call?.outgoing_call_status === "Cancelled",
      );
      setCalls(openCallsList);
      setCompletedCalls(closedCallsList);
      setMeetings(openMeetingsList);
      setCompletedMeetings(closedMeetingsList);
      const open = allTasks.filter((task: any) => task.status !== "Completed");
      const completed = allTasks.filter(
        (task: any) => task.status === "Completed",
      );
      setTasks(open);
      setCompletedTasks(completed);
      setTasksCount(open.length);
      setMeetingsCount(openMeetingsList.length);
      setCallsCount(openCallsList.length);
      setClosedTasksCount(completed?.length);
      setClosedMeetingsCount(closedMeetingsList?.length || 0);
      setClosedCallsCount(closedCallsList?.length || 0);
    } catch (error) {
      setAlertMessage("Failed to fetch task. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchMeetings = async () => {
    if (!customerViewDetails?.id) return;

    setLoading(true);
    try {
      const openMeetings = await getMeetings(
        { customerId: customerViewDetails.id, type: "open" },
        "Customer Profile",
      );
      const openMeetingsList = openMeetings?.data?.data?.meetings || [];
      const closedMeetings = await getMeetings(
        { customerId: customerViewDetails.id, type: "closed" },
        "Customer Profile",
      );
      const closedMeetingsList = closedMeetings?.data?.data?.meetings || [];
      setMeetings(openMeetingsList);
      setCompletedMeetings(closedMeetingsList);
      setMeetingsCount(openMeetings?.data?.data?.count || 0);
      setClosedMeetingsCount(closedMeetingsList?.length || 0);
    } catch (error) {
      setAlertMessage("Failed to fetch task. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const fetchCalls = async (type = "open") => {
    if (!customerViewDetails?.id) return;
    setLoading(true);
    try {
      const response = await getCalls(
        { customerId: customerViewDetails.id, type: type },
        "Customer Profile",
      );
      let allCalls = response?.data?.data?.calls || [];
      if (type === "closed") {
        allCalls = allCalls.filter(
          (call: any) =>
            call?.outgoing_call_status === "Completed" ||
            call?.outgoing_call_status === "Cancelled",
        );
        setCompletedCalls(allCalls);
        setClosedCallsCount(allCalls?.length);
      } else {
        setCalls(allCalls);
        setOpenCallsCount(response?.data?.data?.count || 0);
      }
    } catch (error) {
      setAlertMessage("Failed to fetch calls. Please try again.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerViewDetails) {
      setCustomerOptions([
        {
          value: customerViewDetails?.id || null,
          label: fullName || "",
          email: customerViewDetails?.primary_email || "",
          avatar: customerViewDetails?.profile_url || null,
          resource: "customer",
        },
      ]);
    }
  }, [customerViewDetails]);

  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
    if (activeTab === "Calls") {
      setEditDataCall(null);
      if (e.target.value === "logCall") {
        setOpenLogCallDialog(true);
        setMarkCallAsCompletedOpen(false);
      } else if (e.target.value === "scheduleCall") {
        setOpenCallsDialog(true);
      } else setOpenLogCallDialog(false);
    }
  };

  const findTitleForCallDailog = () => {
    if (openLogCallDialog && !markCallAsCompletedOpen) {
      return "Log Call";
    } else if (markCallAsCompletedOpen) {
      return "Complete Call";
    } else return "Schedule Call";
  };

  const handleeditDataTask = (task: any) => {
    setEditDataTask(task);
    setOpenTaskDialog(true);
  };
  const handleDoneTask = (task: any) => {
    setSelectedArchiveTask(task);
    setIsEditPopupOpen(true);
  };
  const handleMarkTaskCompleted = async () => {
    if (!selectedArchiveTask) return;
    setLoading(true);
    try {
      const updatedTask = {
        subject: selectedArchiveTask.subject,
        ownerId: selectedArchiveTask.owner_id,
        dueDate: selectedArchiveTask.due_date,
        priority: selectedArchiveTask.priority,
        status: "Completed",
        description: selectedArchiveTask.description,
        reminder: selectedArchiveTask.reminder,
        reminderDescription: selectedArchiveTask.reminder_description || "",
        ...(selectedArchiveTask.related_to_lead_id
          ? {
              relatedToLeadId: selectedArchiveTask.related_to_lead_id,
            }
          : { relatedToCustomerId: customerViewDetails?.id }),
      };
      await editTask(selectedArchiveTask.id, updatedTask);

      setAlertMessage("Task marked as completed.");
      setAlertType("success");
      setAlertOpen(true);
      fetchTasks();
    } catch (error) {
      setAlertMessage("Failed to mark task as completed.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsEditPopupOpen(false);
      setSelectedArchiveTask(null);
    }
  };

  const handleDeleteTask = (task: any) => {
    setTaskToDelete(task);
    setIsArchivePopupOpen(true);
  };
  const confirmDeleteTask = async () => {
    if (!taskToDelete) return;
    setLoading(true);
    try {
      await deleteTask(taskToDelete.id);
      setAlertMessage("Task archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchTasks();
    } catch (error) {
      setAlertMessage("Failed to archive task.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchivePopupOpen(false);
      setTaskToDelete(null);
      setLoading(false);
    }
  };

  const handleeditDataMeeting = (meeting: any) => {
    setEditDataMeeting(meeting);
    setOpenMeetingDialog(true);
  };
  const handleDeleteMeeting = (meeting: any) => {
    setMeetingToDelete(meeting);
    setIsArchivePopupOpenForMeeting(true);
  };
  const confirmDeleteMeeting = async () => {
    if (!meetingToDelete) return;
    setLoading(true);
    try {
      await deleteMeeting(meetingToDelete.id);
      setAlertMessage("Meeting archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchMeetings();
    } catch (error) {
      setAlertMessage("Failed to archive meeting.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchivePopupOpenForMeeting(false);
      setMeetingToDelete(null);
      setLoading(false);
    }
  };

  const handleeditDataCall = (call: any) => {
    setEditDataCall(call);
    if (!call?.call_duration) setOpenCallsDialog(true);
    else setOpenLogCallDialog(true);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
    setEditDataCall(row);
  };

  const handleAction = (actionType: string, id: number) => {
    if (actionType === "Reschedule Call") {
      setRescheduleCallOpen(true);
    }
    if (actionType === "Mark As Completed") {
      setMarkCallAsCompletedOpen(true);
      setOpenLogCallDialog(true);
    }
    if (actionType === "Cancel Call") {
      setCancelCallOpen(true);
    }
  };

  const handleMenuOptionClick = (option: any) => {
    if (handleAction) handleAction(option?.label, menuRow?.id);
    handleClose();
  };
  const getActionTypes = (row: any, permissions: any) => {
    return [
      {
        label: "Mark As Completed",
        value: "markAsCompleted",
        id: 1,
        disabled: !permissions?.canWrite,
      },
      {
        label: "Reschedule Call",
        value: "rescheduleCall",
        id: 2,
        disabled: !permissions?.canWrite,
      },
      {
        label: "Cancel Call",
        value: "cancelCall",
        id: 3,
        disabled: !permissions?.canWrite,
      },
    ];
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  const handleDeleteCall = (call: any) => {
    setCallToDelete(call);
    setIsArchiveForCallPopupOpen(true);
  };

  const confirmDeleteCall = async () => {
    if (!callToDelete) return;
    setLoading(true);
    try {
      await deleteCall(callToDelete.id);
      setAlertMessage("Call archived successfully.");
      setAlertType("success");
      setAlertOpen(true);
      fetchCalls("closed");
    } catch (error) {
      setAlertMessage("Failed to archive call.");
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsArchiveForCallPopupOpen(false);
      setCallToDelete(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllCalls = async () => {
      await fetchCalls("open");
      await fetchCalls("closed");
    };
    if (activeTab === "Tasks") {
      fetchTasks();
      fetchMeetings();
      fetchAllCalls();
    }
    if (activeTab === "Meetings") {
      fetchMeetings();
    }
    if (activeTab === "Calls") {
      fetchAllCalls()
    }
  }, [activeTab, customerViewDetails?.id]);
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="customer-view-details-view-open-activities-info">
        <div className="customer-view-details-view-open-activities-info-header">
          <div className="customer-view-details-view-open-activities-info-header-text">
            Open Activities
          </div>
          {activeTab !== "Calls" && (
            <div>
              <button
                className="customer-view-details-view-open-activities-info-header-button"
                onClick={handleAddNewClick}
                disabled={!permissions?.canWrite || !isEmailConfigured}
              >
                Add New
              </button>
            </div>
          )}
          {activeTab === "Calls" && (
            <div className="campaign-list-view-details-view-box-attachment-info-header">
              <div className="add-new-call-dropdown">
                <AddNewCallDropdown
                  selectedOption={selectedOption}
                  handleChange={handleOptionChange}
                  disabled={
                    !permissions?.canWrite ||
                    customerOptions.length === 0 ||
                    !isEmailConfigured
                  }
                />
              </div>
            </div>
          )}
        </div>
        {!isEmailConfigured && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "0px 16px 0px 16px",
            }}
          >
            <EmailSetUpBanner />
          </div>
        )}
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          className="mui-tabs-container"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#887952",
            },
          }}
        >
          {TAB_OPTIONS.map((tab: any) => {
            const count =
              tab.label === "Tasks"
                ? tasksCount
                : tab.label === "Meetings"
                  ? meetingsCount
                  : openCallsCount;

            return (
              <Tab
                key={tab.label}
                sx={{
                  "&.Mui-selected": {
                    color: "#212121",
                  },
                  textTransform: "none",
                }}
                label={
                  <div className="mui-tab-label">
                    <img
                      src={tab.icon}
                      alt={`${tab.label} icon`}
                      className="icon-task"
                    />
                    {tab.label} <span className="tab-count">{count}</span>
                  </div>
                }
                value={tab.label}
              />
            );
          })}
        </Tabs>
        {activeTab === "Tasks" && (
          <div className="customer-view-details-view-open-activities-info-content">
            {tasks && tasks.length > 0 ? (
              <DataTable
                columns={taskColumns}
                data={tasks}
                rowActions={(task) => (
                  <div
                    style={{ display: "flex" }}
                    className={`${!permissions?.canWrite ? "Mui-disabled " : ""}`}
                  >
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleeditDataTask(task);
                      }}
                      className="icon-button"
                      disabled={!permissions?.canWrite}
                    >
                      <img src={EditIcon} alt="edit" className="img-icon" />
                    </IconButton>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDoneTask(task);
                      }}
                      className="icon-button"
                      disabled={!permissions?.canWrite}
                    >
                      <img src={DoneIcon} alt="delete" className="img-icon" />
                    </IconButton>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewTaskvalue({ open: true, taskId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewTaskvalue({ open: false, taskId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.subject, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="customer-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {activeTab === "Meetings" && (
          <div className="customer-view-details-view-open-activities-info-content">
            {meetings && meetings.length > 0 ? (
              <DataTable
                columns={meetingColumns}
                data={meetings}
                rowActions={(meeting) => (
                  <div style={{ display: "flex" }}>
                    <Tooltip className="tooltip" title="Edit">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleeditDataMeeting(meeting);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canWrite}
                      >
                        <img src={EditIcon} alt="edit" className="img-icon" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip className="tooltip" title="Archive">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteMeeting(meeting);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canDelete}
                      >
                        <img
                          src={archiveIcon}
                          alt="archive"
                          className="img-icon"
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewMeetingvalue({ open: true, meetingId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewMeetingvalue({ open: false, meetingId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.title, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="customer-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {activeTab === "Calls" && (
          <div className="customer-view-details-view-open-activities-info-content">
            {calls && calls.length > 0 ? (
              <>
                <DataTable
                  columns={callColumns}
                  data={calls}
                  rowActions={(call) => (
                    <div style={{ display: "flex" }}>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleeditDataCall(call);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canWrite}
                      >
                        <img src={EditIcon} alt="edit" className="img-icon" />
                      </IconButton>
                      <IconButton
                        className="icon-button"
                        disabled={!permissions?.canWrite}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMenuClick(e, call);
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </div>
                  )}
                  onRowClick={(rowData: any) => {
                    setViewCallValue({ open: true, callId: rowData.id });
                    setCrumbMappingOption((prev: any) => {
                      const crumbData = [...prev];
                      crumbData[prev?.length - 1].handleClick = (
                        event: any,
                      ) => {
                        setViewCallValue({ open: false, callId: null });
                        event.preventDefault();
                        setCrumbMappingOption(prev);
                      };
                      return [...crumbData, { label: "View Call", link: "" }];
                    });
                  }}
                />
                <ActionsMenu
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  onOptionClick={handleMenuOptionClick}
                  options={getActionTypes(menuRow, permissions)}
                  width="170px"
                />
              </>
            ) : (
              <div className="customer-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {/* <div className="customer-view-details-view-open-activities-info-no-data">
        No Record Found
      </div> */}
      </div>
      <div className="customer-view-details-view-open-activities-info">
        <div className="customer-view-details-view-open-activities-info-header">
          <div className="customer-view-details-view-open-activities-info-header-text">
            Closed Activities
          </div>
        </div>
        <Tabs
          value={closedActiveTab}
          onChange={(e, newValue) => setClosedActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          className="mui-tabs-container"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#887952",
            },
          }}
        >
          {TAB_OPTIONS.map((tab) => {
            const count =
              tab.label === "Tasks"
                ? closedTasksCount
                : tab.label === "Meetings"
                  ? closedMeetingsCount
                  : closedCallsCount;

            return (
              <Tab
                key={tab.label}
                sx={{
                  "&.Mui-selected": {
                    color: "#212121",
                  },
                  textTransform: "none",
                }}
                label={
                  <div className="mui-tab-label">
                    <img
                      src={tab.icon}
                      alt={`${tab.label} icon`}
                      className="icon-task"
                    />
                    {tab.label} <span className="tab-count">{count}</span>
                  </div>
                }
                value={tab.label}
              />
            );
          })}
        </Tabs>
        {closedActiveTab === "Tasks" && (
          <div className="customer-view-details-view-open-activities-info-content">
            {completedTasks && completedTasks.length > 0 ? (
              <DataTable
                columns={completedTaskColumns}
                data={completedTasks}
                rowActions={(task) => (
                  <div style={{ display: "flex" }}>
                    <Tooltip className="tooltip" title="Archive">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteTask(task);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canDelete}
                      >
                        <img
                          src={archiveIcon}
                          alt="archive"
                          className="img-icon"
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewTaskvalue({ open: true, taskId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewTaskvalue({ open: false, taskId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.subject, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="customer-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {closedActiveTab === "Meetings" && (
          <div className="customer-view-details-view-open-activities-info-content">
            {completedMeetings && completedMeetings.length > 0 ? (
              <DataTable
                columns={meetingColumns}
                data={completedMeetings}
                rowActions={(meeting) => (
                  <div style={{ display: "flex" }}>
                    <Tooltip className="tooltip" title="Archive">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteMeeting(meeting);
                        }}
                        className="icon-button"
                        disabled={!permissions?.canDelete}
                      >
                        <img
                          src={archiveIcon}
                          alt="archive"
                          className="img-icon"
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
                onRowClick={(rowData: any) => {
                  setViewMeetingvalue({ open: true, meetingId: rowData.id });
                  setCrumbMappingOption((prev: any) => {
                    const crumbData = [...prev];
                    crumbData[prev?.length - 1].handleClick = (event: any) => {
                      setViewMeetingvalue({ open: false, meetingId: null });
                      event.preventDefault();
                      setCrumbMappingOption(prev);
                      // setViewOpen(false);
                    };
                    return [...crumbData, { label: rowData.title, link: "" }];
                  });
                }}
              />
            ) : (
              <div className="customer-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
        {closedActiveTab === "Calls" && (
          <div className="customer-view-details-view-open-activities-info-content">
            {completedCalls && completedCalls.length > 0 ? (
              <>
                <DataTable
                  columns={callColumns}
                  data={completedCalls}
                  rowActions={(call) => (
                    <div style={{ display: "flex" }}>
                      <IconButton
                        className="icon-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteCall(call);
                        }}
                        disabled={!permissions?.canDelete}
                      >
                        <img
                          src={archiveIcon}
                          alt="archive"
                          className="img-icon"
                        />
                      </IconButton>
                    </div>
                  )}
                  onRowClick={(rowData: any) => {
                    setViewCallValue({ open: true, callId: rowData.id });
                    setCrumbMappingOption((prev: any) => {
                      const crumbData = [...prev];
                      crumbData[prev?.length - 1].handleClick = (
                        event: any,
                      ) => {
                        setViewCallValue({ open: false, callId: null });
                        event.preventDefault();
                        setCrumbMappingOption(prev);
                      };
                      return [...crumbData, { label: "View Call", link: "" }];
                    });
                  }}
                />
              </>
            ) : (
              <div className="customer-view-details-view-open-activities-info-no-data">
                No Record Found
              </div>
            )}
          </div>
        )}
      </div>
      {/* Dialog for Task only */}
      {activeTab === "Tasks" && (
        <CommonTaskDialog
          open={openTaskDialog}
          onClose={() => {
            setOpenTaskDialog(false);
            setEditDataTask(null);
          }}
          customerDetails={customerViewDetails}
          onSave={() => {
            fetchTasks();
            setOpenTaskDialog(false);
            setEditDataTask(null);
          }}
          title={editDataTask ? "Edit Task" : "Create Task"}
          initialTask={editDataTask}
        />
      )}
      {activeTab === "Meetings" && (
        <CommonMeetingDialog
          open={openMeetingDialog}
          onClose={() => {
            setOpenMeetingDialog(false);
            setEditDataMeeting(null);
          }}
          customerDetails={customerViewDetails}
          onSave={() => {
            fetchMeetings();
            setOpenMeetingDialog(false);
            setEditDataMeeting(null);
          }}
          title={editDataMeeting ? "Edit Meeting" : "Create Meeting"}
          initialMeeting={editDataMeeting}
        />
      )}
      {activeTab === "Calls" && (
        <>
          {
            <CommonCallDialog
              open={openCallsDialog}
              onClose={() => {
                setOpenCallsDialog(false);
                setEditDataCall(null);
                setSelectedOption("");
              }}
              customerDetails={customerViewDetails}
              onSave={() => {
                fetchCalls();
                setOpenCallsDialog(false);
                setEditDataCall(null);
                setSelectedOption("");
              }}
              title={findTitleForCallDailog()}
              initialCall={editDataCall}
              isLogCall={openLogCallDialog}
              customerOptions={customerOptions}
              markCallAsCompletedOpen={markCallAsCompletedOpen}
            />
          }
          {
            <CommonCallLogDialog
              open={openLogCallDialog}
              onClose={() => {
                setEditDataCall(null);
                setOpenLogCallDialog(false);
                setMarkCallAsCompletedOpen(false);
                setSelectedOption("");
              }}
              customerDetails={customerViewDetails}
              onSave={() => {
                fetchCalls("open");
                fetchCalls("closed");
                setOpenLogCallDialog(false);
                setMarkCallAsCompletedOpen(false);
                setEditDataCall(null);
                setSelectedOption("");
              }}
              title={findTitleForCallDailog()}
              initialCall={editDataCall}
              isLogCall={openLogCallDialog}
              customerOptions={customerOptions}
              markCallAsCompletedOpen={markCallAsCompletedOpen}
            />
          }
        </>
      )}
      <div>
        <ConfirmationPopup
          open={isMarkPopupOpen}
          onCancel={() => setIsEditPopupOpen(false)}
          onOkay={handleMarkTaskCompleted}
          title="Mark Completed"
          note="Are you sure you want to mark this task as completed?"
          buttonText="Confirm"
          Icon={ConfirmInfo}
          className="mark-completed-confirmation"
        />
      </div>
      <div>
        <ConfirmationPopup
          open={isArchivePopupOpen}
          onCancel={() => {
            setIsArchivePopupOpen(false);
            setTaskToDelete(null);
          }}
          onOkay={confirmDeleteTask}
          title="Archive Task"
          note={
            taskToDelete
              ? `Are you sure you want to archive "${taskToDelete.subject}"?`
              : "Are you sure you want to archive this task?"
          }
          buttonText="Archive"
        />
      </div>
      <div>
        <ConfirmationPopup
          open={isArchivePopupOpenForMeeting}
          onCancel={() => {
            setIsArchivePopupOpenForMeeting(false);
            setMeetingToDelete(null);
          }}
          onOkay={confirmDeleteMeeting}
          title="Archive Meeting"
          note={
            meetingToDelete
              ? `Are you sure you want to archive the "${meetingToDelete.title}"?`
              : "Are you sure you want to archive this meeting?"
          }
          buttonText="Archive"
        />
      </div>
      <div>
        <ConfirmationPopup
          open={isArchiveForCallPopupOpen}
          onCancel={() => {
            setIsArchiveForCallPopupOpen(false);
            setCallToDelete(null);
          }}
          onOkay={confirmDeleteCall}
          title="Archive Call"
          note={
            callToDelete
              ? `Are you sure you want to archive the call "${callToDelete.subject}"?`
              : "Are you sure you want to archive this call?"
          }
          buttonText="Archive"
        />
      </div>
      <CommonRescheduleCallDialog
        open={rescheduleCallOpen}
        onClose={() => {
          setRescheduleCallOpen(false);
          setEditDataCall(null);
        }}
        initialCall={editDataCall}
        onSave={() => {
          fetchCalls();
          setRescheduleCallOpen(false);
          setEditDataCall(null);
        }}
        title="Reschedule"
        customerDetails={customerViewDetails}
      />

      <CommonCallCancelDialog
        open={cancelCallOpen}
        onClose={() => {
          setCancelCallOpen(false);
          setEditDataCall(null);
        }}
        initialCall={editDataCall}
        onSave={() => {
          fetchCalls();
          fetchCalls("closed");
          setCancelCallOpen(false);
          setEditDataCall(null);
        }}
        title="Cancel"
        customerDetails={customerViewDetails}
      />
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default CustomerViewDetailsViewOpenActivitiesInfo;
